// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-list-agreements{
    background-color: #555555;
    border-radius: 9px;
    height: 80px;
    display: flex;
    color: white;
    padding: 15px 20px;
    align-items: center;
    justify-content: space-between;
    margin-top: 10px;
}
.card-list-agreements-name{
    font-size: 1.1rem;
    text-align: end;
}
.avatar-img{
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background-color: #a3a3a3;
    display: flex;
    justify-content: center;
}
.avatar-img img{
    width: 40px;
}
.card-list-agreements-img{
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background-color: rgb(255, 255, 255);
}
.container-scroll{
    overflow-y: auto;
    padding-bottom: 10px;
    position: absolute;
    top: 75px;
    left: 0px;
    height: calc(100vh - 131px);
}`, "",{"version":3,"sources":["webpack://./src/components/componentsCss/ListCardAgreements.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,8BAA8B;IAC9B,gBAAgB;AACpB;AACA;IACI,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,aAAa;IACb,uBAAuB;AAC3B;AACA;IACI,WAAW;AACf;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,oCAAoC;AACxC;AACA;IACI,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,2BAA2B;AAC/B","sourcesContent":[".card-list-agreements{\n    background-color: #555555;\n    border-radius: 9px;\n    height: 80px;\n    display: flex;\n    color: white;\n    padding: 15px 20px;\n    align-items: center;\n    justify-content: space-between;\n    margin-top: 10px;\n}\n.card-list-agreements-name{\n    font-size: 1.1rem;\n    text-align: end;\n}\n.avatar-img{\n    width: 60px;\n    height: 60px;\n    border-radius: 50%;\n    background-color: #a3a3a3;\n    display: flex;\n    justify-content: center;\n}\n.avatar-img img{\n    width: 40px;\n}\n.card-list-agreements-img{\n    width: 60px;\n    height: 60px;\n    border-radius: 50%;\n    background-color: rgb(255, 255, 255);\n}\n.container-scroll{\n    overflow-y: auto;\n    padding-bottom: 10px;\n    position: absolute;\n    top: 75px;\n    left: 0px;\n    height: calc(100vh - 131px);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
